import * as React from 'react';
import { __ } from '../../helpers/TranslationService';
import { IShipPosition } from '../../interfaces/IShipLivePosition';
import { ShipIconLocation } from '../../components/Icons/ShipIconLocation';
import { white } from '../../consts/variables';
import { Flex } from '../HomeBanner/styled';

const style: Record<string, React.CSSProperties> = {
    positionInfoContentValue: {
        fontSize: 15,
    },
    positionInfoContentTitle: {
        fontWeight: 'bold',
        fontSize: 15,
    },

    positionInfoContent: {
        marginBottom: 5,
    },
};

interface IPositionInfo {
    position: IShipPosition;
}

export const ShipPositionInfo = ({ position }: IPositionInfo) => {
    const latitude = `${__('latitude', 'dreamlines')}: ${position?.lat}°`;

    const longtitude = `${__('longtitude', 'dreamlines')}: ${position?.lon}°`;

    const currentPort = `${position?.currentPort || __('is moving (ship page)', 'dreamlines')} `;

    return (
        <div className="positionWrapper">
            <div className="shipIconLocation">
                <ShipIconLocation className="shipIconLocationIcon" height={60} width={60} />
            </div>

            <div className="shipLocation">
                <span className="positionInfoContentH3">{currentPort}</span>
                <span className="positionInfoContentLat">{latitude}</span>
                <span className="positionInfoContentLong">{longtitude}</span>
            </div>
            <div className="shipInfo">
                {position?.nextPort && position?.nextPort.length > 0 && (
                    <div style={style.positionInfoContent}>
                        <span style={style.positionInfoContentTitle}>{`${__(
                            'next stop',
                            'dreamlines',
                        )}: `}</span>
                        <span style={style.positionInfoContentValue}>{position?.nextPort}</span>
                    </div>
                )}
                {position?.hoursFromDeparture && position?.lastPort && (
                    <div style={style.positionInfoContent}>
                        <span style={style.positionInfoContentTitle}>{`${__(
                            'Departure before (ship page)',
                            'dreamlines',
                        )}: `}</span>
                        <span style={style.positionInfoContentValue}>
                            {__(
                                '%s hours from %s (ship page)',
                                'dreamlines',
                                position?.hoursFromDeparture,
                                position?.lastPort,
                            )}
                        </span>
                    </div>
                )}
                {position?.hoursTillArrival && position?.nextPort && (
                    <div style={style.positionInfoContent}>
                        <span style={style.positionInfoContentTitle}>{`${__(
                            'Arrival in (ship page)',
                            'dreamlines',
                        )}: `}</span>
                        <span style={style.positionInfoContentValue}>
                            {__(
                                '%s hours to %s (ship page)',
                                'dreamlines',
                                position?.hoursTillArrival,
                                position?.nextPort,
                            )}
                        </span>
                    </div>
                )}
                {Boolean(position?.speed) && (
                    <div style={style.positionInfoContent}>
                        <span style={style.positionInfoContentTitle}>{`${__(
                            'Speed (ship page)',
                            'dreamlines',
                        )}: `}</span>
                        <span style={style.positionInfoContentValue}>{`${position?.speed} ${__(
                            'kn',
                            'dreamlines',
                        )}`}</span>
                    </div>
                )}
                {Boolean(position?.course) && (
                    <div style={style.positionInfoContent}>
                        <span style={style.positionInfoContentTitle}>{`${__(
                            'Course (ship page)',
                            'dreamlines',
                        )}: `}</span>
                        <span style={style.positionInfoContentValue}>{`${position?.course}°`}</span>
                    </div>
                )}
            </div>
        </div>
    );
};
